import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rule", "rulesContainer", "summary"]

  connect() {
    this.updateSummary()
  }

  add() {
    const div = document.createElement("div")
    div.className = "flex items-center gap-1.5 mb-2"
    div.setAttribute("data-cancellation-rules-target", "rule")
    div.innerHTML = `
      <span class="text-sm text-neutral-600 whitespace-nowrap">Within</span>
      <input type="number" name="practice[cancellation_rules][][hours_before]" placeholder="any" class="w-14 border border-neutral-300 rounded-lg px-2 py-1.5 text-sm text-center tabular-nums" data-action="input->cancellation-rules#updateSummary">
      <span class="text-sm font-medium text-neutral-700 whitespace-nowrap">hrs</span>
      <span class="text-neutral-300 px-0.5">&rarr;</span>
      <input type="number" name="practice[cancellation_rules][][refund_percent]" min="0" max="100" class="w-14 border border-neutral-300 rounded-lg px-2 py-1.5 text-sm text-center tabular-nums" data-action="input->cancellation-rules#updateSummary">
      <span class="text-sm font-medium text-neutral-700 whitespace-nowrap">% refund</span>
      <button type="button" class="ml-1 text-neutral-400 hover:text-danger-600 cursor-pointer" data-action="click->cancellation-rules#remove" title="Remove rule">
        <i class="fa-solid fa-circle-xmark text-base" aria-hidden="true"></i>
      </button>
    `
    this.rulesContainerTarget.appendChild(div)
    this.updateSummary()
  }

  remove(event) {
    event.target.closest("[data-cancellation-rules-target='rule']").remove()
    this.updateSummary()
  }

  updateSummary() {
    const rules = this.ruleTargets.map(row => {
      const inputs = row.querySelectorAll("input")
      const hours = inputs[0]?.value ? parseInt(inputs[0].value) : null
      const refund = inputs[1]?.value ? parseInt(inputs[1].value) : null
      return { hours, refund }
    }).filter(r => r.refund !== null)

    if (rules.length === 0) {
      this.summaryTarget.classList.add("hidden")
      return
    }

    // Sort by hours ascending, nulls last
    rules.sort((a, b) => {
      if (a.hours === null) return 1
      if (b.hours === null) return -1
      return a.hours - b.hours
    })

    const lines = []
    let prevHours = 0

    rules.forEach((rule, i) => {
      const refundText = rule.refund === 0 ? "no refund" : rule.refund === 100 ? "full refund" : `${rule.refund}% refund`

      if (rule.hours === null) {
        if (prevHours > 0) {
          lines.push(`More than ${prevHours} hours before: ${refundText}`)
        } else {
          lines.push(`Any cancellation: ${refundText}`)
        }
      } else if (prevHours === 0) {
        lines.push(`Less than ${rule.hours} hours before: ${refundText}`)
      } else {
        lines.push(`${prevHours}\u2013${rule.hours} hours before: ${refundText}`)
      }

      prevHours = rule.hours || prevHours
    })

    this.summaryTarget.innerHTML = lines.map(l =>
      `<div class="flex items-center gap-1.5 py-0.5"><span class="text-neutral-400">&bull;</span> ${l}</div>`
    ).join("")
    this.summaryTarget.classList.remove("hidden")
  }
}
